import { useMutation } from "@tanstack/react-query";
import * as yup from "yup";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  shopDomain: yup.string().required(),
});

const responseSchema = yup.object({
  authUrl: yup.string().url().required(),
});

const composeResponse = (res) => {
  return {
    authUrl: res?.data?.data.auth_url,
  };
};

export const useGetShopifyAuthUrlMutation = (options = {}) => {
  return useMutation(async (dto) => {
    const req = await requestSchema.validate(dto, {
      strict: true,
    });
    const res = await http.get(HTTP_ENDPOINTS.getShopifyAuthUrl(), {
      params: {
        shop_domain: req.shopDomain,
      },
    });

    return await responseSchema.validate(composeResponse(res), {
      strict: true,
    });
  }, options);
};
